import {
    Box,
    Button,
    Paper,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    MenuItem,
    FormControl,
    Select,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import styles from "../../../styles.module.css";
import PrintIcon from "@mui/icons-material/Print";
import {
    Breadcrumb,
    Cancel,
    CTSinput,
} from "../../reusableComponent/Reusables";
import SaveIcon from "@mui/icons-material/Save";
import { useDispatch } from "react-redux";
import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
import deliveryChallanService from "../../../services/deliveryChallan.Service";
import LoadingSlipPrint from "./LoadingSlipPrint";
import ReactToPrint from "react-to-print";

const AddLoadingSlip = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const editData = location?.state || null;

    const loginUser = JSON.parse(sessionStorage.getItem("loginUser"));
    const userInfo = loginUser?.result?.userInfo;

    const { handleSubmit } = useForm();

    const [challan, setChallan] = useState([]);
    const [challanData, setChallanData] = useState([]);

    const [formData, setFormData] = useState({
        entry_date: editData?.entry_date || "",
        vehicle_no: editData?.vehicle_no || "",
    });

    const componentRef = useRef();

    useEffect(() => {
        async function fetchInitialData() {
            try {
                const response = await deliveryChallanService.getDeliveryChallanList({
                    page: 0,
                    size: 999,
                    searchKey: "",
                });
                setChallan(response);
            } catch (error) {
                console.error("Initial data fetching failed", error);
            }
        }

        fetchInitialData();
    }, []);

    const fetchFilteredData = async (entry_date, vehicle_no) => {
        try {
            const response = await deliveryChallanService.getDeliveryChallanList({
                page: 0,
                size: 999,
                searchKey: "",
            });

            const filtered = response.filter((item) => {
                const matchesDate = entry_date
                    ? dayjs(item.entry_date).format("YYYY-MM-DD") === dayjs(entry_date).format("YYYY-MM-DD")
                    : true;
                const matchesVehicle = vehicle_no ? item.vehicle_no === vehicle_no : true;
                return matchesDate && matchesVehicle;
            });

            setChallanData(filtered);
        } catch (error) {
            console.error("Error fetching filtered delivery challan data:", error);
            setChallanData([]);
        }
    };

    const handleChange = ({ target }) => {
        const { name, value } = target;
        const updatedForm = { ...formData, [name]: value };
        setFormData(updatedForm);
        fetchFilteredData(updatedForm.entry_date, updatedForm.vehicle_no);
    };

    const onSubmit = () => {
        const timestamp = dayjs().format("YYYY-MM-DD HH:mm:ss");

        const payload = {
            ...formData,
            created_at: editData ? editData.created_at : timestamp,
            created_by: editData ? editData.created_by : userInfo.user_id,
            modified_at: timestamp,
            modified_by: userInfo.user_id,
            changedUpdatedValue: editData ? "edit" : "new",
        };

        console.log("Payload to submit:", payload);
        // dispatch(addLoadingSlip(payload)); // Uncomment when Redux action is available
    };

    return (
        <Paper elevation={3} className={styles.cts_page} sx={{ p: 3, borderRadius: 2 }}>
            <Breadcrumb routeSegments={[{ name: "Loading Slip" }]} />

            <Typography variant="h5" gutterBottom className={styles.add_form_title}>
                {editData ? "Update" : "Create"} Loading Slip
            </Typography>

            <Box className={styles.sm_form}>
                <form onSubmit={handleSubmit(onSubmit)} style={{ width: "100%" }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                            <Typography className={styles.cts_lable_sm} gutterBottom>
                                Loading Date:
                            </Typography>
                            <CTSinput
                                size="small"
                                fullWidth
                                type="date"
                                name="entry_date"
                                value={formData.entry_date}
                                onChange={handleChange}
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Typography className={styles.cts_lable_sm}>Vehicle No:</Typography>
                            <FormControl size="small" fullWidth>
                                <Select
                                    name="vehicle_no"
                                    value={formData.vehicle_no}
                                    onChange={handleChange}
                                    displayEmpty
                                >
                                    <MenuItem value="" disabled>Select Vehicle</MenuItem>
                                    {challan.map((item, index) => (
                                        <MenuItem
                                            key={index}
                                            value={item.vehicle_no}
                                            className={styles.cts_lable}
                                        >
                                            {item.vehicle_no}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12}>
                            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 2 }}>
                                {editData ? (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        type="submit"
                                        startIcon={<SaveIcon />}
                                        id={styles.btn_print}
                                    >
                                        Update
                                    </Button>
                                ) : (
                                    <>
                                        <ReactToPrint
                                            trigger={() => (
                                                <Button variant="contained" color="primary" startIcon={<PrintIcon />} id={styles.btn_print}>
                                                    Print
                                                </Button>
                                            )}
                                            content={() => componentRef.current}
                                            documentTitle="Loading Slip"
                                        />
                                        <div style={{ display: 'none' }}>

                                            <LoadingSlipPrint ref={componentRef} printDetails={challanData[0] || {}} />
                                        </div>

                                        <div style={{ display: "none" }}>
                                            <LoadingSlipPrint ref={componentRef} printDetails={challanData[0] || {}} />
                                        </div>
                                    </>
                                )}
                                
                            </Box>
                        </Grid>
                    </Grid>
                </form>

                {(formData.entry_date || formData.vehicle_no) && (
                    <>
                        {challanData.length > 0 ? (
                            <Box sx={{ mt: 5 }}>
                                <Typography variant="h6" gutterBottom>
                                    Delivery Challan Details
                                </Typography>
                                <Paper>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Customer</TableCell>
                                                <TableCell>Cylinder</TableCell>
                                                <TableCell>Product Code</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {challanData.map((row, idx) => {
                                                let details = [];

                                                try {
                                                    details = Array.isArray(row.table_details)
                                                        ? row.table_details
                                                        : JSON.parse(row.table_details);
                                                } catch (err) {
                                                    console.warn("Failed to parse table_details:", row.table_details);
                                                }

                                                return (
                                                    <TableRow key={idx}>
                                                        <TableCell>{row.to_customer}</TableCell>
                                                        <TableCell>
                                                            {details.map((item) => item.cyl_no).join(", ")}
                                                        </TableCell>
                                                        <TableCell>
                                                            {details.map((item) => item.prod_code).join(", ")}
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                        </TableBody>
                                    </Table>
                                </Paper>
                            </Box>
                        ) : (
                            <Typography variant="body2" color="error" sx={{ mt: 2 }}>
                                No delivery challan data found for the selected criteria.
                            </Typography>
                        )}
                    </>
                )}
            </Box>
        </Paper>
    );
};

export default AddLoadingSlip;
